var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(!_vm.model.deleted_at)?_c('div',{ref:"dropdown",staticClass:"dropdown",class:{ show: _vm.show, dropup: _vm.index > 10, dropleft: true }},[_c('button',{staticClass:"btn btn-secondary dropdown-toggle",attrs:{"type":"button"},on:{"click":function($event){_vm.show = !_vm.show}}},[_vm._v("\n      Aktionen\n    ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",class:{ show: _vm.show }},[_c('div',{staticClass:"dropdown-item",on:{"click":function($event){_vm.$modal.show(_vm.showModalAndHideMenu())}}},[_vm._v("\n        Verlauf\n      ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-item",on:{"click":_vm.edit}},[_vm._v("Bearbeiten")]),_vm._v(" "),_c('div',{staticClass:"dropdown-item",on:{"click":_vm.remove}},[_vm._v("Löschen")])])]):_vm._e(),_vm._v(" "),_c('modal',{attrs:{"width":"80%","height":"auto","pivot-y":0.1,"adaptive":true,"resizable":"","scrollable":"","name":_vm.showPostbackHistoryModalName}},[_c('v-table',{staticClass:"modal-table",attrs:{"url":"/api/v1/postbackActivity","filter":[
        {
          name: 'where',
          attributes: {
            postback_id: this.model.id
          }
        }
      ],"attributes":[
        {
          attribute: 'user_id',
          name: 'User-ID'
        },
        {
          attribute: 'user_email',
          name: 'User-Email'
        },
        {
          attribute: 'amount',
          name: 'Geldbetrag (in € cent)'
        },
        {
          attribute: 'ip',
          name: 'IP'
        },
        {
          attribute: 'created_at',
          name: 'Erstellt am',
          type: 'DateTimeCell'
        },
        {
          attribute: 'postback_data',
          name: 'Link',
          type: 'PostbackDataCell',
          sortable: false
        }
      ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Verlauf der getriggerten Events des Postbacks")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }